import { render, staticRenderFns } from "./modal-button.vue?vue&type=template&id=8ddb3dc6"
import script from "./modal-button.vue?vue&type=script&lang=js"
export * from "./modal-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ddb3dc6')) {
      api.createRecord('8ddb3dc6', component.options)
    } else {
      api.reload('8ddb3dc6', component.options)
    }
    module.hot.accept("./modal-button.vue?vue&type=template&id=8ddb3dc6", function () {
      api.rerender('8ddb3dc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/modal-button.vue"
export default component.exports